import { useRef } from 'react';
import gettext from '@sdk/lang/gettext';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';
import Modal from '@sdk/components/ui/modal/Modal';
import Text14 from '@sdk/components/ui/typography/Text14';
import Column from '@sdk/components/ui/spacing/Column';
import HorizontalSeparator from '@sdk/components/ui/HorizontalSeparator';
import ModalFooterActionButtons from '@sdk/components/ui/modal/ModalFooterActionButtons';
import ModalBodyWithHeader from '@sdk/components/ui/modal/ModalBodyWithHeader';

import { useBillingInfo } from '@web/account/billing/BillingInfoContext';
import DashboardBluePremiumSvg from '@web/assets/svg/Icons/32/dashboard-blue.svg';
import DashboardBlueBusinessSvg from '@web/assets/svg/Icons/32/dashboard-blue-business.svg';

import { useGrant50PercentOffModal } from './grant50PercentOffModal.hooks';

type Props = {
  isVisible: boolean;
  accept: () => void;
  decline: () => void;
};

const Grant50PercentOffModal = ({ isVisible, accept, decline }: Props) => {
  const config = useRef({ noDismiss: true }).current;
  const { grantDiscount } = useGrant50PercentOffModal(accept);
  const { billingInfo } = useBillingInfo();

  return (
    <>
      <Modal fixed config={config} isVisible={isVisible}>
        <ModalBodyWithHeader
          width={620}
          titleThemeColor={ThemeColorType.primary}
          titleText={gettext('Get 50% off your subscription')}
          titleIcon={
            billingInfo.subscriptionLevel === 1 ? (
              <DashboardBluePremiumSvg />
            ) : (
              <DashboardBlueBusinessSvg />
            )
          }
          close={decline}>
          <Column mBottom={20}>
            <Text14 themeColor={ThemeColorType.gray}>
              {gettext(
                "We get it. Running a business is expensive. Before you go, we'd like to offer you 50% off your current Sling plan for the next 12 months."
              )}
            </Text14>
          </Column>
          <HorizontalSeparator />
          <ModalFooterActionButtons
            cancel={decline}
            submit={grantDiscount}
            cancelText={gettext('Nevermind')}
            submitText={gettext('Accept offer')}
          />
        </ModalBodyWithHeader>
      </Modal>
    </>
  );
};

export default Grant50PercentOffModal;
